import { AirFreightZh } from './AirFreight'
import { DomesticMarineTransportationZh } from './DomesticMarineTransportation'
import { RailwayFreightZh } from './DomesticRailwayFreight'
import { DomesticTransportationZh } from './DomesticTransportation'
import { DomesticWarehousingZh } from './DomesticWarehousing'
import { InternationalRailwayFreightZh } from './InternationalRailwayFreight'
import { SeaFreightZh } from './SeaFreight'
import { TankServiceZh } from './TankService'

const zh = {
  UserInterface: {
    CurrentMonth: '当月度',
    CurrentQuarter: '当季度',
    CurrentYear: '当年度',
    OrderQuantity: '订单量',
    CumulativeValue: '累计值',
    OrderQuantityStatistics: '订单量统计',
    MonthOnMonth: '环比上月',
    QuarterOnQuarter: '环比上季度',
    YearOnYear: '环比去年',
    LoginOut: '是否要注销账号？ '
  },
  menu: {
    UserInterface: '用户看板',
    OrderInquiry: '订单查询',
    SeaFreight: '海运',
    AirFreight: '空运',
    InternationalRailwayFreight: '铁路',
    DomesticRailwayFreight: '铁路',
    DomesticTransportation: '运输',
    DomesticMarineTransportation: '水运',
    DomesticWarehousing: '仓储',
    TankService: '罐箱',
    InvoiceInquiry: '发票查询',
    ContractInquiry: '合同查询',
    PointsMall: '积分商城',
    HistoricalRedemptionRecords: '历史兑换记录',
    EvaluationFeedback: '评价反馈',
    ServiceEvaluation: '服务评价',
    Feedback: '意见反馈',
    UserCenter: '用户中心',
    CompanyInformation: '公司信息',
    ChangePassword: '修改密码'
  },
  PointsMall: {
    PointsMall: '积分商城',
    RemainingPoints: '剩余积分',
    ExchangeHistory: '兑换历史',
    IntegratingRange: '积分区间',
    All: '全部',
    LowestPoints: '最低积分',
    HighestPoints: '最高积分',
    Inquire: '查询',
    ClearUp: '清空',
    ExplanationOfRules: '规则说明：客户委托集团内任一公司的主营业务均可获得积分，积分累积方法按所委托业务类型对应 不同积分规则，以订单完成后的开票金额并到账核销后转换为积分，积分终身有效。',
    TheGifts: '礼品类',
    TheService: '服务类',
    GiftExchange: '暂无礼品兑换',
    InputInformation: '信息填写',
    ContactPerson: '联系人',
    TelephoneNumber: '联系人手机号',
    ExchangeNumber: '兑换数量',
    DeliveryAddress: '配送地址',
    Remark: '备注',
    Price: '价格',
    PointsRequired: '所需积分',
    ChooseType: '选择规格',
    Number: '数量',
    Inventory: '库存',
    Exchange: '兑换',
    ProductDetails: '商品详情',
    Evaluation: '评价',
    AllEvaluations: '全部评论',
    NoEvaluation: '暂无评论',
    MarketPrice: '市场价',
    Points: '积分',
    Over: '500,000积分以上',
    filledInIsCorrect: '请确认填写的信息无误！',
    SubmissionSuccessful: '提交成功，工作人员将会在工作日72小时内联系您',
  },
  InvoiceInquiry: {
    InvoiceInquiry: '发票查询',
    InvoiceIssuingEntity: '开票单位',
    PleaseSelect: '请选择',
    NoData: '无数据',
    InvoiceNumber: '发票号',
    PleaseEnter: '请输入',
    TypeOfBill: '票据类型',
    All: '全部',
    Yes: '是',
    No: '否',
    InvoiceType: '发票类型',
    PaymentDate: '应付款日',
    Inquire: '查询',
    Reset: '重置',
    ExportList: '导出列表',
    InvoiceTitle: '发票抬头',
    InvoiceSettlementType: '票据类型',
    InvoiceDate: '发票日期',
    BillingPeriod: '账期',
    InvoiceValue: '发票金额',
    CurrencyType: '币种',
    AmountOfMoney: '金额',
    ReceivableBalance: '应收余额',
    ActualPaymentDate: '实际付款日',
    DaysOverdue: '逾期天数',
    PaidOrNot: '是否已付款',
    PleaseEnterTheContent: '请输入内容',
    Operate: '操作',
    Instructions: '说明',
    Instructions1: '1、以上数据为截止到您当前查询时间前一天的发票情况。',
    Instructions2: '2、请注意若贵司已支付对账单中的金额，我司入账需要1-2天，双方可能会产生时间性差异。',
    Instructions3: '3、若您对此账单有疑问请发送邮件至 mwarteam@mwclg.com，或致电：021-80229869、021-80229861。',
    DownloadInvoice: '下载发票',
    doubts: '有疑问',
    InvoiceDoubtsFeedback: '发票疑问反馈',
    FeedbackContent: '反馈内容',
    return: '返回',
    BillNumber: '账单号',
    InvoiceDetails: '发票明细',
    ExportDetails: '导出明细',
    BusinessNumber: '业务编号',
    FeeName: '费用名称',
    ExpenseAlias: '费用别名',
    price: '单价',
    TaxRate: '税率',
    PaperInvoices: '纸质发票',
    ElectronicInvoice: '电子发票',
    FullElectronicInvoice: '全电发票',
    GeneralInvoice: '普通发票',
    SpecialInvoice: '专用发票',
  },
  ContractInquiry: {
    ContractInquiry: '合同查询',
    AgreementNumber: '密尔克卫协议号',
    LegalEntityOfMilkyway: '密尔克卫法人单位',
    CustomerAgreementNumber: '客户协议号',
    AgreementStatus: '协议状态',
    Valid: '有效',
    Invalid: '无效',
    InCirculation: '流转中',
    NewImportUnconfirmed: '新导入未确认',
    Void: '作废',
    AgreementStartDate: '协议起始日期',
    AgreementEndDate: '协议终止日期',
    SelectDate: '选择日期',
    ContractList: '合同列表',
    CompanyAgreementNumber: '密尔克卫协议号',
    LegalEntity: '法人单位',
    BusinessPartner: '业务伙伴',
    AgreementSigningDate: '协议签署日期',
    StartDate: '协议起始日期',
    EndDate: '协议结束日期',
    NatureOfSignature: '签署性质',
    ClientAgreementNumber: '客户协议号',
    UploadFile: '上传文件',
    AutoRenewal: '是否自动续约',
    RelatedCustomers: '是否有关联客户',
  },
  HistoricalRedemptionRecords: {
    ProductName: '商品名称',
    OrderNumber: '订单编号',
    OrderStatus: '订单状态',
    ProductSpecification: '商品规格',
    Quantity: '数量',
    UsePoints: '使用积分',
    ContactPerson: '联系人',
    TelephoneNumber: '联系电话',
    DeliveryAddress: '配送地址',
    CourierNumber: '快递单号',
    DeliveredOrNot: '是否发货',
    Note: '备注',
    Operate: '操作',
    logisticsInformation: '查看物流',
    Evaluation: '评价',
    Canceled: '已取消',
    Submitted: '已提交',
    Processing: '处理中',
    Finished: '已完成',
    ProductEvaluation: '商品评价',
    QualityOfService: '服务质量',
    EvaluationContent: '评价内容',
    ProductQuality: '商品质量还未评分',
    ServiceQuality: '服务质量还未评分',
    logisticsQuality: '物流质量还未评分',
    EvaluationSuccessful: '评价成功',
    EvaluationFailed: '评价失败，请稍后再试',
    Welcome: '欢迎您！'
  },
  ServiceEvaluation: {
    ServiceEvaluation: '服务评价',
    EvaluationFeedback: '评价反馈',
    EvaluationQuery: '评价查询',
    EvaluatedPerson: '被评价人',
    Position: '岗位',
    CustomerService: '客服',
    Sales: '销售',
    Department: '所在部门',
    Evaluator: '评价人',
    EvaluationList: '评价列表',
    NewEvaluation: '新增评价',
    utterance: '感谢贵司的业务支持！为了贯彻我司“以客户为中心”的宗旨，切实了解我司目前为贵司提供服务的各岗位员工的工作质量，特邀请贵司对我司的服务进行评价。',
    EvaluationPersonnelPositions: '评价对象岗位',
    EvaluatorEmail: '评价人邮箱',
    ServiceAttitude: '服务态度',
    TimelyResponse: '及时响应',
    BusinessCapability: '业务能力',
    ProfessionalCompetence: '专业素养',
    Feedback: '反馈意见',
    Cancel: '取消',
    Confirm: '确定',
    Score: '总分',
    Advice: '意见',
    EvaluationTime: '评价时间',
    notQueried: '未查询到此员工'
  },
  Feedback: {
    Feedback: '意见反馈',
    FeedbackList: '反馈列表',
    NewFeedback: '新增反馈',
    FeedbackType: '意见类型',
    BusinessCategory: '业务类',
    ServiceCategory: '服务类',
    SecurityCategory: '安全类',
    OtherCategories: '其他类',
    SuggestedContent: '建议内容',
    SubmissionDate: '提交日期',
  },
  CompanyInformation: {
    CompanyInformation: '公司信息',
    ContactName: '联系人姓名',
    Name: '称呼',
    Position: '岗位',
    Email: '电子邮件',
    OfficePhoneNumber: '办公室电话',
    MobileTelephone: '移动电话',
    ProvincesCitiesAndDistricts: '省市区',
    DetailedAddress: '详细地址',
    QQNumber: 'QQ号',
    WeChatAccount: '微信号',
    Remarks: '备注',
    Operation: '操作',
    Modify: '修改',
    Delete: '删除',
    AddContactPerson: '新增联系人',
    Ms: '女士',
    Mr: '先生',
    Miss: '小姐',
    Unknown: '不详',
    Save: '保存',
    deleteContacts: '是否删除联系人？',
    Loading: '加载中',
    ContactPersonInformation: '联系人信息',
    YourPhoneNumber: '请输入手机号码',
    DigitPhoneNumber: '请输入11位手机号码',
    LandlinePhoneNumber: '请输入办公室固定电话',
    CodePhoneNumber: '请输入"区号-电话号码", 如：021-80228498'
  },
  ChangePassword: {
    ChangePassword: '修改密码',
    Account: '账号',
    SendVerificationCode: '发送验证码',
    VerificationCode: '验证码',
    NewPassword: '新密码',
    ConfirmPassword: '确认密码',
    Submit: '提交',
    loginAccount: '请输入登录账号',
    EmailAddress: '请输入账号关联的邮箱地址',
    CaptchaCode: '请输入6位邮箱验证码',
    EnterNewPassword: '请输入新密码',
    NewPasswordAgain: '请再次输入新密码',
    Reset: '重置',
    Edit: '修改',
    Inconsistent: '两次输入密码不一致',
    CodeHasBeenSent: '验证码已发送，请登录与账号绑定的邮箱查看',
    PleaseLogInAgain: '请重新登录',
    ForgotPassword: '找回密码',
    Continue: '是否继续?',
    Prompt: '提示',
    LoginInvalid: '登录失效，请重新登录',
    error: '错误'
  },
  AirFreight: AirFreightZh,
  DomesticMarineTransportation: DomesticMarineTransportationZh,
  RailwayFreight: RailwayFreightZh,
  DomesticTransportation: DomesticTransportationZh,
  DomesticWarehousing: DomesticWarehousingZh,
  InternationalRailwayFreight: InternationalRailwayFreightZh,
  SeaFreight: SeaFreightZh,
  TankService: TankServiceZh,
}

export default zh
